import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { StorageKeys, StoragePort } from 'app/core/application/ports/storage.port';

const collectLinks = (items: FuseNavigationItem[] | null | undefined): string[] => {
    if (!items?.length) {
        return [];
    }
    const links: string[] = [];
    for (const item of items) {
        if (item.link) {
            links.push(item.link);
        }
        links.push(...collectLinks(item.children));
    }
    return links;
};

export const getFirstMenuLink = (items: FuseNavigationItem[] | null | undefined): string | null => {
    if (!items?.length) {
        return null;
    }
    for (const item of items) {
        if (item.link) {
            return item.link;
        }
        const childLink = getFirstMenuLink(item.children);
        if (childLink) {
            return childLink;
        }
    }
    return null;
};

export const MenuAccessGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    const storage = inject(StoragePort);
    const router = inject(Router);
    const menu = storage.getItem<FuseNavigationItem[]>(StorageKeys.USER_MENU);
    const allowedLinks = collectLinks(menu);

    const modulePath = '/' + (route.path ?? segments[0]?.path ?? '');
    const isAllowed = allowedLinks.some(
        (link) => link === modulePath || link.startsWith(modulePath + '/'),
    );

    if (isAllowed) {
        return true;
    }

    const fallback = getFirstMenuLink(menu);
    return router.parseUrl(fallback ?? '/sign-in');
};
